import sub_workspace from "@/components/workspace/sub_workspaces.vue" 
export default {
	name 	: "workspace",
	props 	: [
		"layout_id", 
		"ref_to_component",
		"info_to_component",
		"layout",
		"layout_end"
	],
	components : {
		sub_workspace
	}, 
	data 	: (vm) =>({
		head : {
			title 	 : "workstation",
			subtitle : "",
		},
		info 				: {},
		list_workspaces 	: {
			pc : {
				computer : "pc",
				color : "primary",
				small : false,
				large : true,
				states : [
					{
						is_percent 	: true,
						text 		: "cpu",
						percent 	: 50,
						icon  		: "mdi-thermostat-box",
					}
				]
			}
		},
		workspace 	: null,
		show  		: {
			errors 		: false,
			workspace 	: false,
			close 		: true,
		},
		height_card 	: "100%",
		resizing    	: false,

	}), // data
	created(){
		console.log("WORKSPACE CREATED - info_to_component:", this.info_to_component);
		if (this.info_to_component && this.info_to_component.key == 'errors') {
			//this.info = this.$Workspaces.get_workspaces();
			this.show.error = true;

		}else{
			this.show.workspace = true;			
			this.info 			= this.info_to_component;
			console.log("WORKSPACE - setting info:", this.info);
			if (this.info && (this.info.name || this.info.text)) {
				this.head.subtitle = this.info.name || this.info.text;
				// console.log("check_work : ", this.head.subtitle)
			}
		}
      	if (!this.$Helper.current_auth_user(this.currentUser, {roles : [1, 2]})) {
      		this.show.close = false;	
      	}
	}, // created

	watch: {
		layout_end: function(val){
			
			this.resize();
			
			this.$emit('resized_state', false);
		},// layout end
	}, // watch

	computed : {

		render_workspaces : function(){
			return [] //this.$Workspaces.get_workspaces();

		}, // render workspaces 
		currentUser(){
      		return this.$store.state.auth.user;
    	}, // currentUser

	}, // computed

	methods : {
		actions(act, item, opt){
			if (act == 'close_component') {
				this.$emit('close_component', this.layout_id)
			}
		}, // actions

		
		
		resize(){
			if (!this.resizing) {

				this.resizing = true; 
				

				this.$nextTick(()=>{
					if (this.$refs && this.layout_id && this.$refs['card_workspace' + this.layout_id] && this.$refs['card_workspace' + this.layout_id].$el) {
						this.height_card = (this.$refs['card_workspace' + this.layout_id].$el.clientHeight - 38) + 'px'; // 43
						// console.log("refs************************* ", 'card_workspace' + this.layout_id, this.$refs, this.$refs['card_workspace' + this.layout_id])
					}else{
						this.height_card = "100%";
					}
					this.resizing = false;
				});
			}
		}, // resize
	}, // methods

	mounted(){
		this.resize()
	}

}